import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

/**
 * Creates onsite interviews for a posting
 *
 * @param {import('../types/CreateOnsiteInterviews.parameters').ICreateOnsiteInterviewsPayload} payload - Request payload
 * @returns {Promise<import('../types/CreateOnsiteInterviews.api').ICreateOnsiteInterviewsApiResponse>}
 *   Returns 204 No Content on success
 */
export const createOnsiteInterviews = async (payload) => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.post(
    `/posting-service/admin/postings/${payload.postingId}/onsite-interviews`,
    {
      onsiteInterviews: payload.onsiteInterviews,
      duplicate: payload.duplicate,
    },
    {
      headers,
    },
  );

  // 204 No Content - return void/undefined
  if (response.status === 204) {
    return { data: undefined };
  }

  return response.data;
};
